import { useMutation, gql } from "@apollo/client";

import { TEMPLATE_FRAGMENT } from './useGetTemplate';

export const INSERT_TEMPLATE = gql`
  mutation insertTemplate($input: InsertTemplateInput!) {
    insertTemplate(input: $input) {
      template {
        ...TemplateFragment
      }
    }
  }
${TEMPLATE_FRAGMENT}`;

export default (options) => {
  return useMutation(INSERT_TEMPLATE, options);
};
